<app-resource-details [resourceId]="data.id"></app-resource-details>
